// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NLBD","top":"styles_top__r28ag","left":"styles_left__2nv8A","description":"styles_description__3vbE6"};